module.exports = __webpack_public_path__ + "static/media/keywords_Nightingale.34cffb99.JPG";